import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { st, classes } from './SidePanel.st.css.js';
import Header from './Header';
import Content from './Content';
import Footer from './Footer';
import Divider from './Divider';
import { SidePanelContext } from './SidePanelAPI';
class SidePanel extends PureComponent {
    render() {
        const { dataHook, children, className, width, onCloseButtonClick } = this.props;
        return (React.createElement(SidePanelContext.Provider, { value: { onCloseButtonClick } },
            React.createElement("div", { className: st(classes.root, className), "data-hook": dataHook, style: { width } }, children)));
    }
}
SidePanel.displayName = 'SidePanel';
SidePanel.Header = Header;
SidePanel.Content = Content;
SidePanel.Footer = Footer;
SidePanel.Divider = Divider;
SidePanel.propTypes = {
    className: PropTypes.string,
    dataHook: PropTypes.string,
    onCloseButtonClick: PropTypes.func,
    children: PropTypes.node,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
SidePanel.defaultProps = {
    width: '420px',
};
export default SidePanel;
//# sourceMappingURL=SidePanel.js.map